import React from "react";

export default class WebCnArticles extends React.Component {
  render() {
    const { Bs, VARIANT, dataCN, curr } = this.props;
    return (
      <>
        <Bs col xs={12} className="mb-2">
          <Bs row className="mb-2">
            <Bs col xs={6} md={4}>
              <Bs b>Artikl</Bs>
            </Bs>
            <Bs col xs={6} md={4}>
              <Bs b>Počet</Bs>
            </Bs>
            <Bs col xs={6} md={4}>
              <Bs b>Cena (bez DPH)</Bs>
            </Bs>
          </Bs>
        </Bs>
        {dataCN && (
          <>
            {dataCN.map((e) => (
              <Bs col xs={12} className="mb-2">
                <Bs card bg={VARIANT.TRANSPARENT} className="lb-3-secondary">
                  <Bs cardbody>
                    <Bs row className="mb-2">
                      <Bs col xs={6} md={4}>
                        {e.ArticleName}
                      </Bs>
                      <Bs col xs={6} md={4}>
                        {e.ArticleQty}
                      </Bs>
                      <Bs col xs={6} md={4}>
                      {curr} <Bs strong>{e.ArticlePrice}</Bs>
                      </Bs>
                    </Bs>
                  </Bs>
                </Bs>
              </Bs>
            ))}
          </>
        )}
      </>
    );
  }
}
